<template>
  <v-row no-gutters class="pl-10 mt-5 pr-5" justify="space-between" align="center">
    <v-col cols="auto" align-self="start">
      {{ $i18n.t(translationPath) }}
    </v-col>
    <v-col cols="8">
      <v-checkbox
        v-for="n in computedItems"
        :key="n.name"
        :value="n.value"
        v-model="computedValue"
        :label="n.name"
        style="height: 36px"
        class="mt-1"
      >
      </v-checkbox>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'SidebarCheckboxRow',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    translationPath: {
      type: String,
      default: '',
    },
    picked: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.picked;
      },
      set(nV) {
        this.$emit('input', nV);
      },
    },
    computedItems() {
      const old = this.items.map(value => {
        return {
          name: value,
          value: value,
        };
      });
      old.push({ name: 'Brak wartości', value: null });
      return old;
    },
  },
};
</script>

<style scoped lang="scss"></style>
